import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components/macro';

export const ScDepositBonusesSections = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  @media (${device.mobile}) {
    margin-top: 0px;
  }
`;
